import { ICreateRemittanceCreditMemoParams, ICreateRemittanceCreditMemoRepositoryResponse } from "@/core/repositories/accounting";
import { gql, type TypedDocumentNode } from "@apollo/client";

const CREATE_REMITTANCE_CREDIT_MEMO: TypedDocumentNode<ICreateRemittanceCreditMemoRepositoryResponse, {params: ICreateRemittanceCreditMemoParams}> = gql`
  mutation CreateRemittanceCreditMemo($params: CreateRemittanceCreditMemoInput!) {
    createRemittanceCreditMemo(params: $params) {
      status
      remittanceId
      checkNumber
      creditMemoId
      creditMemoAmount
      appliedAmount
      reconciledDeductionIds
      error
      msg
      msgId
      operationBatchId
      creditMemoLines {
        lineItem
        description
        amount
      }
      linkedInvoices {
        externalInvoiceDocumentNumber
        linkedAmount
      }
      linkedCreditMemo {
        creditMemoId
        creditMemoDocumentNumber
        creditMemoTransactionDate
        creditMemoDescription
        invoiceDocumentNumbers
        customerName
        deductionType
        customerId
      }
      queuedDocumentAttachmentCount
    }
  }
`;

export default CREATE_REMITTANCE_CREDIT_MEMO;
